var _rect, _rect2, _path, _path2, _g, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsharpTests({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 80,
    width: 200,
    height: 240,
    rx: 8,
    stroke: "black",
    strokeWidth: 4,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 160,
    height: 30,
    rx: 4,
    stroke: "black",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 115 L150 115",
    stroke: "#3B82F6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 115 L240 115",
    stroke: "black",
    strokeWidth: 2,
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L8 8 L20 -4",
    stroke: "#22C55E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -4,
    width: 100,
    height: 8,
    rx: 2,
    fill: "black",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 40 L8 48 L20 36",
    stroke: "#22C55E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 36,
    width: 80,
    height: 8,
    rx: 2,
    fill: "black",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5 L5 5",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 5 L5 -5",
    stroke: "#EF4444",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 76,
    width: 90,
    height: 8,
    rx: 2,
    fill: "black",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120 L8 128 L20 116",
    stroke: "#22C55E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 116,
    width: 70,
    height: 8,
    rx: 2,
    fill: "black",
    opacity: 0.7
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260 140 L270 160 L260 180",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 100,
    r: 6,
    fill: "#22C55E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 300,
    r: 6,
    fill: "#3B82F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 300,
    r: 6,
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharpTests);
export default __webpack_public_path__ + "static/media/csharp-tests.1f58702975dd49b3d5672fe115f59194.svg";
export { ForwardRef as ReactComponent };